import _ from "lodash";
import { deepCopy } from "../../../Utils/Global";
import {
  SET_DASHBOARD_VARIABLES,
  SET_DASHBOARD_VARIABLE_VALUE,
  RESET_DASHBOARD_VARIABLE_VALUE,
  RESET_DASHBOARD_VARIABLE_VALUES
} from "./DashboardVariableAction";

/**
 * Reducer for Dashboard Variables
 */
export default function DashboardVariableReducer(
  state = {
    dashboardVariables: [], // [{ id, dataType, defaultValue, name, source }]
    activeValues: new Map(), // id -> value
  },
  action
) {
  switch (action.type) {
    case SET_DASHBOARD_VARIABLES: {
      let dashboardVariables = Array.isArray(action.payload) ? action.payload : [];

      // Normalize if array of [key, value] pairs
      if (
        dashboardVariables.length > 0 &&
        Array.isArray(dashboardVariables[0]) &&
        dashboardVariables[0].length === 2 &&
        typeof dashboardVariables[0][1] === "object"
      ) {
        dashboardVariables = dashboardVariables.map((entry) => entry[1]);
      }

      const activeValues = new Map();
      dashboardVariables.forEach((def) => {
        const varId = def.id || def.name;
        const oldDef = state.dashboardVariables.find(v => (v.id || v.name) === varId);

        if (state.activeValues.has(varId)) {
          const currentVal = state.activeValues.get(varId);
          const oldDefault = oldDef?.hasOwnProperty("defaultValue") ? oldDef.defaultValue : null;

          // If the active value was equal to the old default value, update it to the new default value
          if (oldDef && _.isEqual(currentVal, oldDefault)) {
            activeValues.set(varId, def.hasOwnProperty("defaultValue") ? def.defaultValue : null);
          } else {
            activeValues.set(varId, currentVal);
          }
        } else {
          activeValues.set(varId, def.hasOwnProperty("defaultValue") ? def.defaultValue : null);
        }
      });

      return {
        ...state,
        dashboardVariables,
        activeValues,
      };
    }

    case SET_DASHBOARD_VARIABLE_VALUE: {
      const activeValues = deepCopy(state.activeValues);
      const variableDefinition = state.dashboardVariables.find(
        (v) => v.id === action.payload.variableId,
      );

      if (!variableDefinition) return state;

      let valueToSet;
      const payloadValue = action.payload.value;
      const isPayloadValueArray = Array.isArray(payloadValue);
      const isCurrentDashboardVariableSingle =
        variableDefinition.inputType === "single";

      if (isCurrentDashboardVariableSingle) {
        if (isPayloadValueArray) {
          valueToSet = payloadValue[payloadValue.length - 1];
        } else {
          valueToSet = payloadValue;
        }
      } else {
        if (isPayloadValueArray) {
          valueToSet = payloadValue;
        } else {
          valueToSet = [payloadValue];
        }
      }
      activeValues.set(action.payload.variableId, valueToSet);
      return {
        ...state,
        activeValues
      };
    }

    case RESET_DASHBOARD_VARIABLE_VALUE: {
      const activeValues = deepCopy(state.activeValues);
      const def = state.dashboardVariables.find(v => v.id === action.payload);

      if (!def) return state;

      const defaultValue = def.hasOwnProperty("defaultValue") ? def.defaultValue : null;

      if (_.isEqual(activeValues.get(def.id), defaultValue)) {
        return state;
      }

      activeValues.set(action.payload, defaultValue);

      return {
        ...state,
        activeValues
      };
    }

    case RESET_DASHBOARD_VARIABLE_VALUES: {
      const activeValues = deepCopy(state.activeValues);
      const dashboardVariables = state.dashboardVariables;

      dashboardVariables.forEach((def) => {
        activeValues.set(def.id, def.hasOwnProperty("defaultValue") ? def.defaultValue : null);
      });

      return {
        ...state,
        activeValues
      };
    }

    default:
      return state;
  }
}
